// components/WishlistToggle.jsx
// Wishlist state comes from WishlistContext: API for logged-in users, localStorage only for guests.
import { IconButton } from "@mui/material";
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { useWishlist } from "../context/WishlistContext";

export default function WishlistToggle({ product }) {
  const { addToWishlist, removeFromWishlist, isInWishlist } = useWishlist();
  const productId = product.article_id ?? product.id;
  const inWishlist = isInWishlist(productId);

  const handleToggle = (e) => {
    e.stopPropagation();
    if (inWishlist) {
      removeFromWishlist(productId);
    } else {
      addToWishlist({
        id: productId,
        article_id: product.article_id ?? product.id,
        name: product.title || product.enhanced_name || product.name || "Product",
        price: product.price ?? product.price_info?.price ?? 0,
        image: product.image ?? (Array.isArray(product.images) ? product.images[0] : null),
      });
    }
  };

  return (
    <IconButton
      onClick={handleToggle}
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: 1,
        p: 1.25,
        "&:hover": {
          bgcolor: "action.hover",
        },
      }}
    >
      {inWishlist ? (
        <Favorite sx={{ color: "error.main", fontSize: 20 }} />
      ) : (
        <FavoriteBorder sx={{ color: "grey.700", fontSize: 20 }} />
      )}
    </IconButton>
  );
}